import React, { useState, useEffect } from "react";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import axiosHttp from "../../Config";
import Loader from "../../Components/Loader";
// import postImg from "../../Assets/Images/post-1.png";
import ReactPaginate from "react-paginate";
import ReusableModal from "../../Components/Modal";
import SinglePost from "../../Components/SinglePost";
import profile from "../../Assets/Images/undraw_profile.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

const PostDetails = () => {
  const [postList, setPostList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageData, setPageData] = useState({
    currentPage: 1,
    totalPages: 1,
  });
  const [entries, setEntries] = useState(10);
  const [key, setKey] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  // const [postCount, setPostCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [postId, setPostId] = useState({});

  useEffect(() => {
    fetchPostsList(pageData.currentPage, entries, key);
  }, [pageData.currentPage, entries, key]);

  const fetchPostsList = async (current, count, key) => {
    setLoading(true);
    try {
      const apiUrl = key !== ""
        ? `popular-post-details?page=${current}&per_page=${count}`
        : `user-post-details?page=${current}&per_page=${count}`;
      
      console.log('PostDetails API URL:', apiUrl);
      console.log('PostDetails API Parameters:', { current, count, key });
      
      const getPostList = await axiosHttp.get(apiUrl);
      
      console.log('PostDetails API Response:', getPostList);
      console.log('PostDetails API Status:', getPostList.status);
      
      if (getPostList.status === 200) {
        let data = getPostList.data.data;
        let page = getPostList.data.meta;
        
        console.log('PostDetails Data:', data);
        console.log('PostDetails Pagination Meta:', page);
        console.log('PostDetails First Post Object:', data[0]);
        
        setPageData({
          currentPage: page.currentPage,
          totalPages: page.lastPage,
        });
        setPostList(data);
        // fetchPostCount(key, search);
        setLoading(false);
      }
    } catch (error) {
      console.log('PostDetails API Error:', error);
      setPostList([]);
      setPageData({
        currentPage: 1,
        totalPages: 1,
      });
      // setPostCount(0);
      setLoading(false);
    }
  };

  // const fetchPostCount = async (key) => {
  //   try {
  //     const getUserCount = await axiosHttp.get(
  //       key !== "" ? `posts-count?filter=${key}` : `posts-count`
  //     );
  //     if (getUserCount.status === 200) {
  //       let data = getUserCount.data.data;
  //       setPostCount(data.count);
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     setPostCount(0);
  //     setLoading(false);
  //   }
  // };

  const handlePageClick = (event) => {
    setPageData({ ...pageData, currentPage: event.selected + 1 });
  };

  const openModal = (id) => {
    setShowModal(true);
    setPostId(id);
  };

  const closeModal = () => {
    setPostId({});
    setShowModal(false);
  };

  // Search functionality to filter posts by username
  const getFilteredPosts = () => {
    if (!searchTerm.trim()) {
      return postList;
    }
    
    const searchLower = searchTerm.toLowerCase().trim();
    
    return postList.filter(post => {
      const userName = post?.user_name?.toLowerCase() || "";
      return userName.includes(searchLower);
    });
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="container-fluid top-container">
      <div className="card  card-one-1 mb-5">
        <div className="card-body">
          <h4 className="title mb-4">Post Details</h4>

          <div className="row ml-1">
            <div className="col-md-6 mt-3">
              <nav className="mt-4 ad-tab-nav">
                <Tabs id="nav-tab" activeKey={key} onSelect={(k) => setKey(k)}>
                  <Tab eventKey="" title="All Post" />
                  <Tab eventKey="popular" title="Popular Post" />
                </Tabs>
              </nav>
            </div>
            <div className="col-md-6 mt-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search by username..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          {/* <div className="col-md-4 mt-5 text-right">
              <p className="text-danger">{postCount} posts</p>
            </div> */}
          <div className="row mx-3">
            {/* {postList.length === 0 && <p>No posts available</p>} */}
            {/* {postList.length > 0 &&
              postList.map((post) => {
                let { id, url, type } = post;
                return (
                  <div
                    className="col-md-2 mt-4 cursor-pointer"
                    key={id}
                    onClick={() => openModal(post)}
                  >
                    <img
                      src={type === "video" ? postImg : url}
                      className="img-fluid post-img"
                      alt="post-img"
                    />
                  </div>
                );
              })} */}
            <div className="table-responsive mt-3">
              <table
                className="table table-bordered"
                id="dataTable"
                width="100%"
                cellspacing="0"
              >
                <thead className="bg-col">
                  <tr>
                    <th className="border-right-0 ">
                      <input
                        type="checkbox"
                        className="form-control check-box "
                      />
                    </th>
                    <th>User Name</th>
                    <th>User Link</th>
                    <th>{key === "" ? "Post Count" : "Likes Count"}</th>
                    {key !== "" && <th>Actions</th>}
                  </tr>
                </thead>
                <tbody>
                  {getFilteredPosts().length === 0 && (
                    <p className="mt-2">No Data Available</p>
                  )}
                  {getFilteredPosts().length > 0 &&
                    getFilteredPosts().map((post) => {
                      return (
                        <tr key={post.id}>
                          <td className="text-center border-right-0 ">
                            <input
                              type="checkbox"
                              className="form-control check-box "
                            />
                          </td>
                          <td className="border-right-0 ">
                            <img
                              className="img-profile rounded-circle photo mr-2"
                              src={post.pic_url ? post.pic_url : profile}
                              alt="profile"
                            />{" "}
                            {post?.userName || "User"}
                          </td>
                          <td className="border-right-0 ">
                            {post?.user_name ? (
                              <a
                                href={`https://upskillmeet.com/${post?.user_name}`}
                                target="_blank"
                                rel="noreferrer"
                                className="txt-active"
                              >
                                {`https://upskillmeet.com/${post?.user_name}`}{" "}
                              </a>
                            ) : null}
                          </td>
                          {key === "" ? (
                            <td className="border-right-0 ">
                              {post?.post_count || 0}
                            </td>
                          ) : (
                            <td className="border-right-0 ">
                              {post?.likes_count || 0}
                            </td>
                          )}

                          {key !== "" && (
                            <td>
                              <span>
                                <FontAwesomeIcon
                                  icon={faEye}
                                  className="bg-success text-white p-1 rounded mr-3 cursor-pointer"
                                  onClick={() => openModal(post?.postId)}
                                />
                              </span>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="d-flex mt-5 justify-content-between ">
          <div className="col-sm-12 col-md-6">
            <label className="d-flex align-items-center">
              Show{" "}
              <select
                className="form-control entry-select ml-2 mr-2"
                value={entries}
                onChange={(e) => setEntries(Number(e.target.value))}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              entries
            </label>
          </div>
          {pageData.totalPages > 1 && (
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageData.totalPages}
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination justify-content-end"
              activeClassName="active"
              previousLabel="<"
              forcePage={pageData.currentPage - 1}
            />
          )}
        </div>
      </div>
      <ReusableModal
        show={showModal}
        onHide={closeModal}
        title="View Post"
        size="md"
      >
        <SinglePost post={postId} />
      </ReusableModal>
    </div>
  );
};

export default PostDetails;
